import { combineReducers } from 'redux-immutable'
import efficiencyGetReducer from './efficiency-get-reducer'
import efficiencyLOBGetReducer from './efficiency-lob-get-reducer'
import efficiencyLOBExportReducer from './efficiency-lob-export-reducer'
import efficiencyEditReducer from './efficiency-edit-reducer'
import efficiencySubmitReducer from './efficiency-submit-reducer'
import efficiencyManualReducer from './efficiency-manual-reducer'

export default combineReducers({
  efficiencyGet: efficiencyGetReducer,
  efficiencyLOBGet: efficiencyLOBGetReducer,
  efficiencyLOBExport: efficiencyLOBExportReducer,
  efficiencyEdit: efficiencyEditReducer,
  efficiencySubmit: efficiencySubmitReducer,
  efficiencyManual: efficiencyManualReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/efficiency-resource/index.js